import i18n from '@/lang'
import defaultSettings from '@/settings'
import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { goLogin } from '@/utils'
import store from '@/store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  if (i18n.te(`route.${to.meta.title}`)) {
    const pageName = i18n.t(`route.${to.meta.title}`)
    document.title = `${pageName} - ${defaultSettings.title}`
  } else {
    document.title = defaultSettings.title
  }

  if (store.getters.token) {
    next()
    NProgress.done()
  } else {
    goLogin()
    NProgress.done()
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
